import _ from "lodash";
import React, {Component} from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";

import {getTweets} from '../../actions';
import TwtsCarousel from './TwtsCarousel';
import LoadingSpinner from 'utils/LoadingSpinner/';

import tweetPollStyle from "assets/jss/material-kit-react/views/pollTemplateSections/tweetPollStyle.jsx";

class TweetSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      twt_ids: [],
      carouselSecHeight: null,
      config: {
        // slideIndex: 0,            // can use to manually change index
        // visibleTwts: 3,           // NOTE passing this as a param now
        pxSpaceBetweenTwts: 15,
        carouselPadding: "15px",     // TODO need to tweak this so only on sides? why so much padding below?
        twtsToScrollBy: 2,
        autoInterval: 3000,           // ms
        scrollSpeed: 2500,              // ms
        cellAlign: "left",
        transitionMode: "scroll", // fade, scroll
        heightMode: "max",        // first, current, max   //TODO needs tweaking... dont like it
      },
    };
  }

  componentDidMount() {
    // console.log('on mount', this.props.poll.data);
    const {poll} = this.props;
    if (!_.isEmpty(poll.data) && !poll.gettingTwts) {
      this.getTwts();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // QUESTION this a backup check, but shouldnt need this???
    this.checkNewPoll(prevProps);
  }

  getTwts() {
    const {question, answers} = this.props.poll.data;
    const strOfAns = answers.map(a => {return a.answer}).join(" ");
    // console.log('next', strOfAns);
    // console.log('before get twts', `${question} ${strOfAns}`);
    this.props.getTweets(`${question} ${strOfAns}`);
  }

  checkNewPoll(prvProps) {
    if (prvProps) {
      if (prvProps.poll.data !== this.props.poll.data) {
        console.log('getting new twts, on update');
        this.getTwts();
      }
    }
  }

  checkCarouselRef() {
    // console.log('checking refs...')
    // first time this gets called, TwtCarousel does not exist yet
    if (this.TwtCarousel) {
      // console.log('init car: ', this.TwtCarousel.clientHeight)
      const {carouselSecHeight} = this.state;
      const newCarouselSecHeight = this.TwtCarousel.clientHeight + 150;
      // console.log('checking client h:', this.TwtCarousel.clientHeight);
      // console.log('checking car h:', carouselSecHeight);
      if (carouselSecHeight === null) {
        this.setState({carouselSecHeight: 450});
        // this.setState({carouselSecHeight: newCarouselSecHeight});
        // console.log("null -> set car h: ", newCarouselSecHeight);
      } else if (carouselSecHeight !== newCarouselSecHeight && this.TwtCarousel.clientHeight !== 0) {
        this.setState({carouselSecHeight: newCarouselSecHeight});
        // console.log("reset -> car h: ", newCarouselSecHeight);
      }
    }
  }

  renderCarousel() {
    const {twt_ids, gettingTwts} = this.props.poll;

    // should always have at least a default set of twt ids
    if (gettingTwts || !twt_ids) {
      return <LoadingSpinner />
    } else {
      return (
        <TwtsCarousel
          config={this.state.config}
          checkRefs={()=>this.checkCarouselRef()}
          twts={twt_ids}
        />
      );
    }
  }

  render() {
    const {classes} = this.props;
    const {carouselSecHeight} = this.state;
    const carHeight = carouselSecHeight ? carouselSecHeight : 450;
    // console.log("slide h: ", this.TwtCarousel ? this.TwtCarousel.state.slideHeight : 0);

    return (
      <div className={classes.section} style={{height: carHeight}} >
        <div
          ref={(twtcarousel) => this.TwtCarousel = twtcarousel}
          style={{width: "100%"}}
        >
        {this.renderCarousel()}
        </div>
      </div>
    );
  }
}

const pageWithStyles = withStyles(tweetPollStyle)(TweetSection);
function  mapStateToProps(state) {
  return {
    poll: state.poll,
  }
}
export default withRouter(connect(mapStateToProps, {getTweets})(pageWithStyles));



// WEBPACK FOOTER //
// ./src/views/PollTemplate/TweetSection.js